<div class="page-area">
    <div class="basic-boxes">
        <div class="basic-details basic-details2">
            <div class="basic-title">
                <h5>Manual Punch</h5>
            </div>
            <div class="basic-contbox">
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>From Date</h5>
                    </div>
                    <div class="emp-input">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Punch ID</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Punch ID" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>Employee</h5>
                    </div>
                    <div class="emp-input">
                        <input nz-input placeholder="Employee" [(ngModel)]="value" />
                    </div>
                </div>
                <div class="grace-btnbox">
                    <ul>
                        <li>
                            <a href="javascript:void(0);">
                                <span><i nz-icon nzType="search" nzTheme="outline"></i></span>
                                Search
                            </a>
                            <a href="javascript:void(0);">
                                <span><i nz-icon nzType="clear" nzTheme="outline"></i></span>
                                Clear
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="basic-cont basic-cont2">
                    <div class="emp-title">
                        <h5>New Punch</h5>
                    </div>
                    <div class="emp-input dep-input-box">
                        <nz-date-picker [(ngModel)]="date" (ngModelChange)="onChange($event)"></nz-date-picker>
                        <a href="javascript:void(0);" class="dep-btn">Add New Punch</a>
                    </div>
                </div>

                <div class="manual-list">
                    <ul>
                        <li>
                            <span>Shift</span>
                            <span><strong>: OFFICE</strong></span>
                        </li>
                        <li>
                            <span>Start Time</span>
                            <span><strong>: 09:00</strong></span>
                        </li>
                        <li>
                            <span>End Time</span>
                            <span><Strong>: 18:30</Strong></span>
                        </li>
                    </ul>
                </div>


            </div>
        </div>

        <div class="basic-details basic-details3">
            <div class="tabledata">
                <!-- <div class="tabletop-description">
                    <div class="t-description">
                        <h5>Main Department</h5>
                        <a href="#">Print & Export</a>
                    </div>
                </div> -->
                <nz-table #fixedTable [nzData]="listOfData2" [nzSize]="'small'">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Punch Date Time</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of fixedTable.data">
                            <td>{{ data.name }}</td>
                            <td>{{ data.age }}</td>
                            <td>{{ data.address }}</td>
                            <td><i nz-icon nzType="delete" nzTheme="outline"></i></td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </div>
    </div>
</div>